import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type { DeficiencyActionedList } from './deficiencyActionedList.types';

export const deficiencyActionedListPullQueryBuilder = (document: DeficiencyActionedList) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query actionedDataForActiveDeficiencies(
      $siteId: Int!
      $disciplineId: Int!
      $lastRequested: DateTime
      $isLeadInspector: Boolean!
    ) {
      actionedDataForActiveDeficiencies(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
        isLeadInspector: $isLeadInspector
      ) {
        assetId
        assetName
        isActive
        workPackageId
        workOrderId
        inspectionStatus
        componentFailureId
        workRequestId
        site
        discipline
        dateCreated
        dateModified
        capMapProjectId
        capMapTaskId
        fkComponentRemovalCategory
        componentRemovalCategory
        componentRemovalComments
        workPackageStatus
        workRequestStatus
        workOrderStatus
        pkDeficiencyUUID
        componentFailureStatus
        tMAppliedDate
        tMClosureDate
      }
    }
  `);

  const variables = {
    siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
    disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
    lastRequested: getDateModified(
      doc?.dateModified,
      doc?.dateCreated,
      doc.site,
      doc.discipline,
      JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
    ),
    isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
  };

  return {
    query,
    variables,
  };
};
